"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _provider = _interopRequireDefault(require("./modules/provider"));

var _searchResults = _interopRequireDefault(require("./modules/searchResults"));

var _searchParams = _interopRequireDefault(require("./modules/searchParams"));

var _user = _interopRequireDefault(require("./modules/user"));

var _messages = _interopRequireDefault(require("./modules/messages"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var store = {
  state: {
    api: null
  },
  getters: {
    api: function api(state) {
      return state.api;
    }
  },
  modules: {
    provider: _provider["default"],
    searchResults: _searchResults["default"],
    searchParams: _searchParams["default"],
    user: _user["default"],
    messages: _messages["default"]
  }
};
var _default = store;
exports["default"] = _default;


// WEBPACK FOOTER //
// ../capital-finder-vuex/lib/store.js